import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute } from '@nu-art/ts-common';
export const ApiDef_MultiVar = {
    _v1: {
        deleteMultiVarColumn: { method: HttpMethod.POST, path: '/v1/multi-var/delete-multi-var-column', timeout: 3 * Minute },
        deleteMultiVar: { method: HttpMethod.GET, path: '/v1/multi-var/delete-multi-var', timeout: 3 * Minute },
        saveMultiVar: { method: HttpMethod.POST, path: '/v1/multi-var/save-multi-var', timeout: 3 * Minute },
        deleteReference: { method: HttpMethod.POST, path: '/v1/multi-var/delete-reference' },
    }
};
//# sourceMappingURL=api-def.js.map